import { requestFetch } from '@repo/common-utils';

export const checkMaintenance = async () => {
  try {
    const res = await requestFetch('/api/maintenance');
    if (!res.ok) return false;
    const data = await res.json();
    return data.status === true;
  } catch {
    return false;
  }
};
